import { useFeature, useIsEmbedded } from '../../scripts/selectors/global';
import { FeatureFlag } from '../../../gameConfig/sharedTypes';

/**
 * Returns true if moderation reporting is enabled and we're not in an embedded context.
 * Consolidates the common `useFeature(MODERATION_REPORTING_ENABLED) && !useIsEmbedded()` pattern.
 */
export function useModerationReportingEnabled(): boolean {
  const isReportingEnabled = useFeature(FeatureFlag.MODERATION_REPORTING_ENABLED);
  const isEmbedded = useIsEmbedded();
  return isReportingEnabled && !isEmbedded;
}
